(ns frontend.view.entity-viewers.modules.attachments
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require
   [cljs.core.async :as async]
   [clojure.edn :as edn]
   [common.localization :as loc]
   [common.schema.field :as field]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [frontend.actions.entity :as entity-actions]
   [frontend.components.field-editor :as field-editor]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.utils :as fu]
   [frontend.view.components.upload :as upload]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.folder-selection-modal.view :as folder-selection-modal]
   [oops.core :as oops]
   [potpuri.core :refer [dissoc-in]]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.link.view :as link]
   [ui.dom-globals :as dg]
   [ui.editors.data-input :as data-input]
   [ui.enrich.existing :as enrich-existing]
   [ui.util :as uu]))

(defn add-indicator!
  [local-atom token file-name]
  (swap! local-atom assoc-in [:uploading token] {:file-name file-name}))

(defn read-progress
  [channel state upload-token]
  (async/take!
   channel
   (fn [progress]
     (let [{:keys [direction loaded total]} progress
           prog (/ loaded total)]
       (cond (= :download direction)
             (swap! state assoc-in [:uploading upload-token :progress] 100.0)
             (= :upload direction)
             (do (swap! state assoc-in [:uploading upload-token :progress] (* 100 (float prog)))
                 (swap! state assoc-in [:uploading upload-token :status] :uploading)))
       (when (= :upload direction)
         (read-progress channel state upload-token))))))

(defn add-attachment!
  [{:keys [local-atom success! db/id]} e]
  (let [file (aget (:files e) 0)
        file-name (.-name file)
        attachment {:filename    file-name
                    :description nil
                    :file        file
                    :target      id}
        prog-channel (async/chan)
        token-success! (fn [token]
                         (add-indicator! local-atom token file-name)
                         (read-progress prog-channel local-atom token)
                         (attachment-actions/*=>add-attachment
                          {:multipart-params (assoc attachment :token token)
                           :progress         prog-channel}
                          (fn [resp]
                            (swap! local-atom assoc-in [:uploading token :status] :complete)
                            (when success!
                              (success! (:body resp))))
                          (fn [e]
                            (logging/error "Error in uploading attachment" e)
                            (swap! local-atom assoc-in [:uploading token :status] :error))))]
    (common-actions/*<-create-op-token nil
                                       token-success!
                                       (fn [e]
                                         ;;TODO show error-bar
                                         (logging/error "resp token=" e)))))

(defn remove-attachment!
  [target-id attachment]
  (attachment-actions/*<-remove-attachment
   {:target-id target-id :attachment-id (:db/id attachment)}
   (partial logging/unimplemented "remove-attachment! Success")
   (partial logging/error "remove-attachment! failed")))

(defn upload-area
  [local-atom entity-id success! args]
  [upload/upload-zone
   (merge {:css-class  "attachments-module-upload-zone"
           :on-change! (fn [e]
                         (add-attachment! {:db/id      entity-id
                                           :success!   success!
                                           :local-atom local-atom}
                                          e))}
          args)])

(defn indicators
  [local-atom _entity-id]
  [:div.upload-indicators
   (->> @local-atom
        :uploading
        (remove (fn [[_token meta]]
                  (= (:status meta) :complete)))
        (map
         (fn [[token meta]]
           (let [{:keys [file-name progress status]} meta]
             [:div
              {:key        (str "uploading-indicator-" token)
               :class-name (fu/cs "upload-indicator" status)}
              (when (some #{status} [:error :uploading])
                (let [progress (or progress 0.0)]
                  [:span.upload-indicator__bar
                   {:style {:width (str (oops/ocall (js/Number. progress) "toFixed" 2) "%")}}]))
              [:div
               {:class-name "grid grid-cols-10 gap-4 px-4 z-[1]"}
               [:div
                {:class-name "col-span-5"}
                [:label.upload-indicator__label
                 [:span
                  (case status
                    :uploading (loc/tr :file-upload-indicator-label)
                    :error (loc/tr :file-upload-error-label)
                    "")]]]
               [:div
                {:class-name "col-span-5 text-right"}
                [:span.d-flex.align-items-center.justify-content-end
                 (when (some #{status} [:error :uploading])
                   (let [progress (or progress 0.0)]
                     [:span.d-inline-block.pr-3.text-color--light-grey.text-size--xs
                      (str (oops/ocall (js/Number. progress) "toFixed" 2) "%")]))
                 (when (not= :uploading status)
                   [:i.fas.fa-times-circle.text-color--danger.d-inline-block.pr-1
                    {:on-click (fn [_]
                                 (swap! local-atom dissoc-in [:uploading token]))}])]]
               [:div
                {:class-name "col-span-10"}
                [:span.text-size--sm file-name]]]])))
        (doall))])

(defn move-to-folder
  [attachment folder-names]
  (modals/open-modal! folder-selection-modal/modal-key
                      {:entity       attachment
                       :folder-names folder-names}))

(defn attachment-view
  [{:keys [folder-names attachment target-id hide-delete?]}]
  (let [{:keys [attachment/filename attachment/av-status]} attachment
        infected? (= av-status :INFECTED)]
    (when filename
      [:div
       [:div
        (when-not infected?
          {:class    "flex items-center gap-4 group"
           :on-click #(fu/open-attachment! (:db/id attachment))})
        [:div
         {:class "flex gap-2 cursor-pointer"}
         [:span
          {:class "m-0 text-sm text-base-light-text-paler"}
          [:i.fal.fa-file]]
         [:span filename]]
        [:div
         [:div
          {:class "hidden group-hover:flex flex-nowrap gap-2 *:p-0"}
          ;(:attachment/folder-path attachment)
          ;; The row opens the attachment on click, so keep the robot's click here.
          (when-not infected?
            [:span {:on-click dg/stop-propagation}
             [enrich-existing/start-button-for
              {:entity-id     target-id
               :attachment-id (:db/id attachment)}]])
          (when (seq folder-names)
            [button/secondary-open
             {:on-click (without-default-action-and-propagation
                         (move-to-folder attachment folder-names))}
             [:div
              [:i.fal.fa-folder-open]]])
          (when-not infected?
            [button/secondary-open
             {:on-click (without-default-action-and-propagation
                         (fu/open-attachment! (:db/id attachment)))}
             [:i.fal.fa-external-link]])
          (when-not infected?
            [button/secondary-open
             {:on-click (without-default-action-and-propagation
                         (fu/download-attachment! (:db/id attachment)))}
             [:i.fal.fa-cloud-download]])
          (when-not (or (session/is-read-only-user?)
                        hide-delete?)
            [button/secondary-open
             {:on-click (without-default-action-and-propagation
                         (modals/open-modal!
                          delete-confirmation-modal/modal-key
                          {:body       (loc/tr :attachment-delete)
                           :on-delete! #(remove-attachment! target-id attachment)}))}
             [:i.fal.fa-trash-alt]])]]
        (when infected?
          [fu/tooltip-overlay {:id (str "infected-attachment" (:db/id attachment))}
           (loc/tr :infected-attachment-warning-tooltip)
           [:span.infected (loc/tr :infected-attachment-warning)]])]])))

(defn folder-view
  [local-atom folder-name all-attachments all-folders entity-id]
  (let [show-attachments (->> all-attachments
                              (filter (fn [a]
                                        (let [in-folder? (= (str "/" (cu/str-trim-lcase folder-name))
                                                            (cu/str-trim-lcase (:attachment/folder-path a)))]
                                          in-folder?))))
        open? (get @local-atom folder-name)]
    [:li
     {:class    "flex flex-col gap-2 cursor-pointer"
      :on-click (fn [_]
                  (if (get @local-atom folder-name)
                    (swap! local-atom assoc folder-name false)
                    (swap! local-atom assoc folder-name true)))}
     [:div
      {:class "flex gap-2 items-center"}
      [:span
       {:class "inline-block w-7"}
       [:i
        {:class (uu/cm "w-7 inline-block text-xl"
                       "fas"
                       (if open?
                         "fa-folder-open"
                         "fa-folder"))}]]
      [:span
       {:class "font-semibold"}
       folder-name]]
     (when open?
       (->> show-attachments
            (map (fn [attachment]
                   ^{:key (str "attachment-" entity-id
                               "-" (or (:db/id attachment)
                                       attachment))}
                   [:div
                    {:class "pl-8"}
                    [attachment-view
                     {:attachment   attachment
                      :folder-names all-folders
                      :target-id    entity-id}]]))
            (doall)))]))

(defn network-drive
  [{:keys [entity-atom]}]
  (let [tenant-schema @session/tenant-schema
        field-schema (registry/get-field-schema tenant-schema :common/network-drive)
        field-schema (merge field-schema
                            {:access/type (f-permissions/access-to-field-long
                                           :common/network-drive
                                           (:entity/type @entity-atom)
                                           (fu/pipeline-id @entity-atom))
                             :editor/type (->> field-schema
                                               :field/default-visibility
                                               :editor)})
        state-atom (r/atom {})]
    (fn [{:keys [entity-atom]}]
      (let [entity @entity-atom
            value (:common/network-drive entity)
            read-only?
            (not (f-permissions/field-write-access? :common/network-drive
                                                    (:entity/type @entity-atom)
                                                    (fu/pipeline-id @entity-atom)))]
        [field-editor/view
         (merge
          field-schema
          ;;TODO cleanup (mostly copy-pasting here)
          {:drag-options {:hide-drag-area? true}
           :state-atom   state-atom                                                                 ;; state is passed  from outside so debugging is easier
           :value        value
           :class-name   (fu/cs (:class-name field-schema) (when empty? "empty pl-0"))
           ;; TODO: take language from user / tenant config -> default to :en
           ;; if only :en in field/translations use :en
           :label        (or (->> field-schema
                                  :field/translations
                                  :en)
                             (loc/tr :common/network-drive))                                            ;; we select label outside of field-editor so we can customize label if needed
           :read-only?   read-only?
           :disabled?    read-only?
           :placeholder  (field/placeholder field-schema)
           ;; tools are configured by need - all handlers are inside as currently the tools have no side effects
           :tools        [:tool-item/cancel :tool-item/save :tool-item/edit :tool-item/copy
                          :tool-item/open-url]
           :on-save!     (fn [attribute new-value on-success! on-error!]
                           (when-not (= new-value value)
                             ;;optimistic save to frontend db:
                             (swap! entity-atom assoc attribute new-value)
                             (entity-actions/*->field-update!
                              (:db/id entity)
                              attribute
                              new-value
                              (fn [_res]
                                (when on-success!
                                  (on-success!)))
                              (fn [err]
                                ;;retract the optimistic save above
                                (when (= new-value (get @entity-atom attribute))
                                  (swap! entity-atom assoc attribute value))
                                (on-error! err)))))})]))))

(defn network-drive-item-editor
  [idx state-atom]
  (let [field-label (get-in @state-atom [:common/named-network-drives idx :label])
        field-url (get-in @state-atom [:common/named-network-drives idx :url])]
    [:div
     {:class "w-11/12 flex flex-col gap-3"}
     [:<>
      [:div
       [:label
        {:class "text-xs block pb-2 font-bold capitalize"}
        (loc/tr :label)]
       [data-input/view
        {:data-type :data.type/text-simple
         :class     "w-full"
         :value     field-label
         :on-change #(swap! state-atom assoc-in [:common/named-network-drives idx :label] %)}]]

      [:div
       [:label
        {:class "text-xs block pb-2 font-bold"}
        (loc/tr :url)]
       [data-input/view
        {:data-type :data.type/text-url
         :class     "w-full"
         :value     field-url
         :on-change #(swap! state-atom assoc-in [:common/named-network-drives idx :url] %)}]]]]))

(defn network-drive-item
  [{:keys [label url]}]
  (when-not (cu/blank-value? url)
    [:<>
     [:label
      {:class "m-0 font-semibold truncate text-sm min-w-0"}
      label]
     [link/view
      {:url   url
       :class "min-w-0 break-words text-sm"}]]))

(defn valid-network-drives?
  [entity-atom state-atom]
  (let [old-value (:common/named-network-drives @entity-atom)
        new-value (:common/named-network-drives @state-atom)]
    (and (not= old-value new-value)
         (->> new-value
              (map :label)
              (filter nil?)
              (empty?)))))

(defn save-network-drives!
  [entity-atom state-atom]
  (let [old-value (:common/named-network-drives @entity-atom)
        new-value (:common/named-network-drives @state-atom)
        new-stored-value (pr-str new-value)]
    (swap! state-atom :processing? true)
    ;; optimistic save
    (swap! entity-atom assoc :common/named-network-drives new-value)
    (entity-actions/*->field-update!
     (:db/id @entity-atom)
     :common/named-network-drives
     new-stored-value
     (fn [_res]
       (reset! state-atom @entity-atom))
     (fn [_err]
       (swap! state-atom dissoc :processing?)
       ;;retract the optimistic save above
       (when (= new-value (get @entity-atom :common/named-network-drives))
         (swap! entity-atom assoc :common/named-network-drives old-value))))))

;; Read-only viewer - currently used in entity-merge:
(defn network-drives-viewer
  [{:keys [entity]}]
  (let [values (:common/named-network-drives entity)]
    [:div
     {:class "p-3 mt-2 bg-base-regular rounded "}
     [:ul
      {:class "flex flex-col gap-3 min-w-0"}
      (->> values
           (map-indexed (fn [idx item]
                          ^{:key (str "network-drive-" idx)}
                          [:div
                           {:class "flex flex-col min-w-0 overflow-hidden"}
                           [network-drive-item item]]))
           (doall))]]))

(defn network-drives
  [{:keys [entity-atom]}]
  (let [state-atom (r/atom @entity-atom)]
    (fn [{:keys [entity-atom]}]
      (let [entity @state-atom
            values (:common/named-network-drives entity)
            read-only? (not (f-permissions/field-write-access?
                             :common/named-network-drives
                             (:entity/type @entity-atom)
                             (fu/pipeline-id @entity-atom)))
            edit? (:edit? @state-atom)
            not-valid-changes? (and edit?
                                    (not (valid-network-drives? entity-atom state-atom)))]
        [:div
         [:div
          {:class "mt-2 min-w-0"}
          [:ul
           {:class "flex flex-col gap-2 min-w-0"}
           (->> values
                (map-indexed (fn [idx item]
                               (if edit?
                                 ^{:key (str "network-drive-" idx)}
                                 [:li
                                  {:class "p-3 relative rounded border border-solid border-base-light-border-paler"}
                                  [button/square-secondary-open
                                   {:on-click (fn []
                                                (swap! state-atom update
                                                       :common/named-network-drives
                                                       (fn [old-drives]
                                                         (->> old-drives
                                                              (remove (fn [d]
                                                                        (= d item)))
                                                              (vec)))))
                                    :class    "absolute top-2 right-2"}
                                   [:i.fas.fa-times-circle]]
                                  [:div
                                   [network-drive-item-editor idx state-atom]]]
                                 ^{:key (str "network-drive-" idx)}
                                 [:div
                                  {:class "flex flex-col gap-3 p-3 bg-base-regular rounded min-w-0 overflow-hidden"}
                                  [network-drive-item item]])))
                (remove nil?)
                (doall))]
          (when-not read-only?
            (if-not edit?
              [:div
               {:class "absolute top-3.5 right-3"}
               [button/square-secondary-open
                {:on-click #(swap! state-atom assoc :edit? true)}
                [:i.fal.fa-cog]]]
              [:<>
               [:div
                {:class "flex gap-3 mt-3"}
                [button/helper-button
                 {:on-click (fn []
                              (swap! state-atom update
                                     :common/named-network-drives
                                     (fn [old-drives]
                                       (vec (concat old-drives
                                                    [{:url   "https://"
                                                      :label (str (loc/tr :network-drive [(count values)]))}])))))}
                 (loc/tr :add-network-drive)]]
               [:div
                {:class "flex gap-3 mt-3"}
                [button/sm-secondary-hollow
                 {:on-click (fn []
                              (reset! state-atom @entity-atom))}
                 (loc/tr :cancel)]
                [button/sm-primary-solid
                 {:disabled? (or (:processing? @state-atom)
                                 not-valid-changes?)
                  :on-click  #(save-network-drives! entity-atom state-atom)}
                 (loc/tr :save)]]]))]]))))
#_(merge
   field-schema
   ;;TODO cleanup (mostly copy-pasting here)
   {:drag-options {:hide-drag-area? true}
    :state-atom   state-atom                                                                        ;; state is passed  from outside so debugging is easier
    :value        value
    :class-name   (fu/cs (:class-name field-schema) (when empty? "empty pl-10 pl-sm-15"))
    ;; TODO: take language from user / tenant config -> default to :en
    ;; if only :en in field/translations use :en
    :label        (or (->> field-schema
                           :field/translations
                           :en)
                      (loc/tr :common/network-drive))                                                   ;; we select label outside field-editor, so we can customize label if needed
    :read-only?   read-only?
    :disabled?    read-only?
    :placeholder  (field/placeholder field-schema)
    ;; tools are configured by need - all handlers are inside as currently the tools have no side effects
    :tools        [:tool-item/cancel :tool-item/save :tool-item/edit :tool-item/copy
                   :tool-item/open-url]
    :on-save!     (fn [attribute new-value on-success! on-error!]
                    (when-not (= new-value value)
                      ;;optimistic save to frontend db:
                      (swap! entity-atom assoc attribute new-value)
                      (entity-actions/*->field-update!
                       (:db/id entity)
                       attribute
                       new-value
                       (fn [res]
                         (when on-success!
                           (on-success!)))
                       (fn [err]
                         ;;retract the optimistic save above
                         (when (= new-value (get @entity-atom attribute))
                           (swap! entity-atom assoc attribute value))
                         (on-error! err)))))})

(defn render
  [local-atom {:keys [entity-atom entity-id attachments pipeline-atom] :as _args}]
  (let [show-network-drive? (f-permissions/field-read-access?
                             :common/network-drive
                             (:entity/type @entity-atom)
                             (fu/pipeline-id @entity-atom))
        show-network-drives? (f-permissions/field-read-access?
                              :common/named-network-drives
                              (:entity/type @entity-atom)
                              (fu/pipeline-id @entity-atom))
        attachments (->> attachments
                         (remove nil?)
                         (sort-by :attachment/created)
                         reverse)
        folders (merge {}
                       (when-let [fs (:common/folder-structure @entity-atom)]
                         (cond (map? fs)
                               fs
                               (string? fs)
                               (edn/read-string fs)))
                       (when pipeline-atom
                         (when-let [pipeline @pipeline-atom]
                           (when-let [fs (:common/folder-structure pipeline)]
                             (cond (map? fs)
                                   fs
                                   (string? fs)
                                   (edn/read-string fs))))))
        folder-names (->> folders
                          (keys)
                          (remove cu/blank-value?)
                          (sort-by cu/str-trim-lcase))
        low-folders (->> folder-names
                         (map cu/str-trim-lcase))
        attachments-without-folder-path (->> attachments
                                             (filter (fn [a]
                                                       (let [folder-path (:attachment/folder-path a)]
                                                         (or (cu/blank-value? folder-path)
                                                             (not (some #{(cu/str-trim-lcase (subs folder-path 1))} low-folders)))))))]
    [:div
     {:class "p-2"}
     (when show-network-drive?
       [network-drive {:entity-id entity-id :entity-atom entity-atom}])
     (when show-network-drives?
       [network-drives {:entity-id entity-id :entity-atom entity-atom}])
     [:ul
      {:class "py-2 flex flex-col gap-3"}
      (doall
       (for [attachment attachments-without-folder-path]
         ^{:key (str "attachment-" entity-id
                     "-" (or (:db/id attachment)
                             attachment))}
         [attachment-view
          {:attachment   attachment
           :folder-names folder-names
           :target-id    entity-id}]))
      (->> folder-names
           (map (fn [folder-name]
                  ^{:key (str "attachment-" entity-id "-folder-" folder-name)}
                  [folder-view local-atom folder-name attachments folder-names entity-id]))
           (doall))]
     [indicators local-atom entity-id]
     (when-not (session/is-read-only-user?)
       [upload-area local-atom entity-id identity {:lang-kw :en}])]))

(defn view
  [{:keys [entity-id]}]
  (let [local-atom (r/atom {})
        entity-atom (r/cursor session/entities [entity-id])
        pipeline-id (when entity-atom
                      (fu/pipeline-id @entity-atom))
        pipeline-atom (when pipeline-id
                        (r/cursor session/entities [pipeline-id]))]
    (r/create-class
     {:reagent-render (fn [args]
                        (render local-atom
                                (merge args
                                       {:entity-atom   entity-atom
                                        :pipeline-atom pipeline-atom})))})))
